import reduce from 'lodash/reduce';

export default function encodeUriObject(object: any) {
  return reduce(
    object,
    (str: string, v: any, k: any) =>
      `${str ? `${str}&` : str}${encodeURIComponent(k)}=${encodeURIComponent(
        v
      )}`,
    ''
  );
}
